import { useNavigate } from "react-router-dom";
import FacebookNews from "./FacebookNews";
import PageMeta from "./PageMeta";

export default function NewsPage() {
  const navigate = useNavigate();

  return (
    <div className="page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <PageMeta
        title="Latest News | Redruth Sea Angling Association"
        description="The latest news, results and updates from Redruth Sea Angling Association, Cornwall's sea angling club since 1962."
        keywords="RSAA news, sea angling club news Cornwall, Redruth Sea Angling Association updates"
        url="https://www.redruthseaanglingassociation.co.uk/news"
      />
      <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="mb-8 flex items-center gap-4">
          <button type="button" onClick={() => navigate(-1)}
            className="standalone-only group inline-flex items-center gap-1.5 rounded-full border border-cyan-400/20 bg-white/5 px-4 py-2 text-sm font-medium text-slate-200 shadow-lg shadow-black/20 backdrop-blur transition hover:-translate-x-0.5 hover:border-cyan-300/40 hover:bg-cyan-400/10 hover:text-white">
            ← Back
          </button>
          <div>
            <h1 className="heading-glow text-2xl font-bold text-white sm:text-3xl">Latest News</h1>
            <p className="mt-1 text-sm text-slate-400">Latest RSAA news from Facebook</p>
          </div>
        </div>

        <div className="mb-6">
          <a
            href="https://www.facebook.com/profile.php?id=100086902542471"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-xl border border-cyan-300/40 bg-cyan-400/15 px-4 py-2 text-sm font-semibold text-cyan-300 transition hover:bg-cyan-400/25"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
              <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"/>
            </svg>
            Visit our Facebook Group
          </a>
        </div>

        <div className="overflow-hidden rounded-[2rem]">
          <FacebookNews />
        </div>
      </div>
    </div>
  );
}
